import axios from 'axios'

import store from '../vuex'

const api = {
  url: process.env.VUE_APP_MAPIT_API,
  __zohoUrl: 'https://zohoserver.mapit.me/tickets?xml=',
  sendRequest(type, url, cb, token, body) {
    const http = new XMLHttpRequest()
    http.open(type, `${this.url}${url}`, true)
    http.setRequestHeader('Content-type', 'application/json')
    if (token) http.setRequestHeader('Authorization', token)
    http.setRequestHeader('X-App-Origin', 'honda')
    http.onreadystatechange = () => {
      if (http.readyState === 4) {
        if (http.status === 200) {
          cb(
            null,
            http.responseText && http.responseText.length > 0 ? JSON.parse(http.responseText) : http.responseText,
          )
        } else {
          try {
            if (http.status == 401) {
              store.dispatch('logout')
              window.location.replace('/login')
            }
            let error = JSON.parse(http.responseText)
            error._status = http.status
            cb(error, null)
          } catch (err) {
            //catch for special errors response
            cb({error: 'Response server error', response: http.response, err}, null)
          }
        }
      }
    }
    if (body) {
      http.send(JSON.stringify(body))
    } else {
      http.send()
    }
  },
  async sendAxiosRequest({method, url, params, body}) {
    return axios
      .request({
        url,
        params,
        method,
        baseURL: this.url,
        data: body,
        headers: {
          Authorization: store.getters.getToken,
          'X-App-Origin': 'honda',
        },
      })
      .then(res => {
        return res.data
      })
      .catch(err => {
        if (err.response && err.response.data.error) throw Error(err.response.data.error)
        else throw err
      })
  },

  getSupervisors(filters, cb, numPage, maxPage) {
    if (numPage) {
      this.sendRequest(
        'POST',
        `admin/supervisors?page=${numPage}&max=${maxPage ? maxPage : 200}`,
        (err, resp) => {
          if (err) {
            return cb(err)
          }
          cb(
            null,
            resp.map(item => {
              if (item.ownerDetail) {
                item.ownerDetail = JSON.parse(item.ownerDetail)
                item.fullName = (item.ownerDetail.Name + ' ' + item.ownerDetail.Surname).toLowerCase()
                item.phone = item.ownerDetail.Phone
                if (!item.ownerLogin) {
                  if (item.ownerDetail.InfoEmail)
                    item.ownerLogin = item.ownerDetail.InfoEmail.toLowerCase() + ' (detail)'
                  else item.ownerLogin = '-'
                }
                item.showDetail = false
                item.containers = {}
              }
              return item
            }),
          )
        },
        store.getters.getToken,
        filters,
      )
    } else {
      this.sendRequest(
        'POST',
        'admin/supervisors/',
        (err, resp) => {
          if (err) {
            return cb(err)
          }
          for (let i = 0; i < resp.length; i++) {
            if (resp[i].ownerDetail) {
              resp[i].ownerDetail = JSON.parse(resp[i].ownerDetail)
              resp[i].fullName = (resp[i].ownerDetail.Name + ' ' + resp[i].ownerDetail.Surname).toLowerCase()
              resp[i].phone = resp[i].ownerDetail.Phone
              if (!resp[i].ownerLogin) {
                if (resp[i].ownerDetail.InfoEmail)
                  resp[i].ownerLogin = resp[i].ownerDetail.InfoEmail.toLowerCase() + ' (detail)'
                else resp[i].ownerLogin = '-'
              }
              resp[i].showDetail = false
              resp[i].containers = {}
            }
          }
          cb(null, resp)
        },
        store.getters.getToken,
        filters,
      )
    }
  },

  uploadVIN(branch, csv) {
    return this.sendAxiosRequest({
      method: 'post',
      url: 'vin/upload',
      body: {
        vins: csv,
        branch,
      },
    })
  },
}

export default api
